<template>
  <div class="pending-items-container">
<!--    <div class="toggle-view-mode mb-3">-->
<!--      <v-btn-toggle v-model="viewMode" mandatory>-->
<!--        <v-btn flat :value="'list'">-->
<!--          <v-icon>mdi-format-list-bulleted</v-icon>-->
<!--        </v-btn>-->
<!--        <v-btn flat :value="'grid'">-->
<!--          <v-icon>mdi-grid</v-icon>-->
<!--        </v-btn>-->
<!--      </v-btn-toggle>-->
<!--    </div>-->

    <!-- Vista em Lista -->
    <div v-if="viewMode === 'list'" class="pending-list-view">
      <draggable :options="{ delay: dragDelay }">
        <div
          class="pending-list-item elevation-1"
          v-for="(item, index) in items"
          :key="index"
          @click.stop="openFolder(item.id)"
          @dragstart="startDrag(item.id)"
          @dragend="setDraggingItem(null)"
          @mousedown="startTimer(item.id)"
          @mouseup="stopTimer"
          @mouseleave="stopTimer"
          :class="{ 'dragging': item.id === draggingItemId }"
        >
          <!-- Indicador colorido na borda do card -->
          <div
            class="status-indicator"
            :class="{
              'review': item.pending_type === 'review',
              'signature': item.pending_type === 'signature'
            }"
          ></div>

          <v-flex row class="pending-item-container">
            <div class="pending-item-main">
              <!-- Coluna 1: Informações da pasta -->
              <div class="folder-info">
                <div class="folder-icon-container">
                  <img
                    class="folder-icon"
                    :src="item.current_owner && user && item.current_owner.id === user.id ?
                      '/static/images/folder/folder-open-icon.svg' :
                      '/static/images/folder/folder-closed-icon.svg'"
                    alt="Ícone de Pasta"
                  >
                </div>
                <div class="folder-details">
                  <v-tooltip bottom max-width="300">
                    <template v-slot:activator="{ on }">
                      <div class="process-number" v-on="on">{{ item.process_number }}</div>
                    </template>
                    <span class="custom-tooltip">{{ item.process_number }}</span>
                  </v-tooltip>
                  <v-tooltip bottom max-width="300">
                    <template v-slot:activator="{ on }">
                      <div class="folder-type-name" v-on="on">{{ item.folder_type.name }}</div>
                    </template>
                    <span class="custom-tooltip">{{ item.folder_type.name }}</span>
                  </v-tooltip>
                </div>
              </div>

              <!-- Coluna 2: Entidade -->
              <div class="entity-info">
                <v-tooltip bottom max-width="500">
                  <template v-slot:activator="{ on }">
                    <v-chip class="entity-chip" v-on="on">
                      <v-avatar size="24" class="mr-1">
                        <v-icon size="16" color="grey">mdi-briefcase</v-icon>
                      </v-avatar>
                      <span class="entity-name">{{ truncateEntityName(item.entity.name) }}</span>
                    </v-chip>
                  </template>
                  <span class="custom-tooltip">{{ item.entity.name }}</span>
                </v-tooltip>
              </div>

              <!-- Coluna 3: Proprietário e Unidade Administrativa -->
              <div class="pending-item-owner">
                <v-layout align-center>
                  <v-flex>
                    <v-chip
                      v-if="item.current_owner"
                      x-small
                      outlined
                      class="mt-1"
                      outline
                      :color="getStatusColor(item.current_owner)"
                    >
                      {{ item.current_owner.name }}
                    </v-chip>
                  </v-flex>
                </v-layout>
              </div>

              <!-- Coluna 4: Prazo -->
              <div class="pending-item-deadline">
                <v-layout align-center>
                  <v-icon
                    :color="isOverdue(item.limit_date) ? 'error' : ''"
                    size="18"
                    class="mr-1"
                  >
                    {{ isOverdue(item.limit_date) ? 'mdi-alert-circle' : 'mdi-calendar' }}
                  </v-icon>
                  <v-flex>
                    <div class="deadline-date" :class="{'red--text': isOverdue(item.limit_date)}">
                      {{ formatDate(item.limit_date) }}
                    </div>
                    <div class="deadline-relative caption" :class="{'red--text': isOverdue(item.limit_date)}">
                      {{ getRelativeTime(item.limit_date) }}
                    </div>
                  </v-flex>
                </v-layout>
              </div>
            </div>

            <!-- Detalhes do documento com pendência -->
            <div class="pending-document-details" v-if="getDocumentPendingFolder(item)">
              <!-- Coluna 5: Status -->
              <div class="pending-item-status">
                <v-chip
                  :color="getStatusColor(item)"
                  small
                  :class="getStatusTextColor(item)"
                  class="status-chip px-3 py-3"
                >
                  <v-icon size="16" left>{{ getStatusIcon(item) }}</v-icon>
                  {{ getStatusText(item) }}
                </v-chip>
              </div>
              <v-layout v-if="getDocumentPendingFolder(item)" align-center class="document-type-info ml-2">
                <v-icon size="24" class="mr-1" :color="getDocumentIconColor(getDocumentPendingFolder(item))">
                  {{ getDocumentTypeIcon(getDocumentPendingFolder(item)) }}
                </v-icon>
                <span class="document-type-text">{{ getDocumentType(getDocumentPendingFolder(item)) }}</span>
              </v-layout>
              <div class="pending-actions">
                <v-btn
                  small
                  outlined
                  color="primary"
                  class="view-btn"
                  @click.stop="showDocument(item, getDocumentPendingFolder(item))"
                >
                  <v-icon size="16" left>mdi-file-eye</v-icon>
                  Visualizar documento
                </v-btn>
              </div>
            </div>
          </v-flex>
        </div>
      </draggable>
    </div>

    <!-- Vista em Grid -->
    <div v-else class="pending-grid-view">
      <v-container fluid grid-list-md>
        <v-layout row wrap>
          <v-flex
            v-for="(item, index) in items"
            :key="index"
            xs12 sm6 md4 lg3
          >
            <v-card
              class="pending-grid-card elevation-1"
              hover
              @click.stop="openFolder(item.id)"
              :class="{
                'review-indicator': item.pending_type === 'review',
                'signature-indicator': item.pending_type === 'signature'
              }"
            >
              <v-card-title class="pending-grid-header">
                <v-layout align-center>
                  <img
                    class="folder-icon mr-2"
                    :src="item.current_owner && user && item.current_owner.id === user.id ?
                      '/static/images/folder/folder-open-icon.svg' :
                      '/static/images/folder/folder-closed-icon.svg'"
                    alt="Ícone de Pasta"
                  >
                  <span class="process-number">{{ item.process_number }}</span>
                </v-layout>
              </v-card-title>

              <v-divider></v-divider>

              <v-card-text class="pending-grid-content">
                <!-- Tipo da pasta -->
                <v-chip
                  small
                  class="folder-type-chip mb-2"
                  label
                >
                  {{ item.folder_type.name }}
                </v-chip>

                <!-- Entidade -->
                <v-chip class="entity-chip mb-2 text-truncate">
                  <v-avatar size="16">
                    <v-icon size="14" color="grey">mdi-briefcase</v-icon>
                  </v-avatar>
                  <span>{{ truncateEntityName(item.entity.name) }}</span>
                </v-chip>

                <!-- Documento com pendência -->
                <div v-if="getDocumentPendingFolder(item)" class="document-name mt-2">
                  <v-icon size="14" class="mr-1">
                    {{ item.pending_type === 'review' ? 'mdi-file-document-edit' : 'mdi-file-sign' }}
                  </v-icon>
                  {{ getDocumentPendingFolder(item).name }}
                </div>
              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions class="pending-grid-footer">
                <!-- Proprietário e unidade -->
                <v-layout column>
                  <v-layout align-center class="mb-1">
                    <v-avatar size="24" class="owner-avatar mr-2">
                      <img
                        v-if="item.current_owner && item.current_owner.avatar && item.current_owner.avatar.url"
                        :src="item.current_owner.avatar.url"
                        alt="Avatar"
                      >
                      <span v-else class="white--text">{{ getInitials(item.current_owner) }}</span>
                    </v-avatar>
                    <span class="owner-name truncate-text">
                      {{ item.current_owner ? item.current_owner.name : 'Sem proprietário' }}
                    </span>
                  </v-layout>

                  <v-layout align-center justify-space-between>
                    <v-chip
                      v-if="item.current_owner && item.current_owner.administrative_unit"
                      x-small
                      outlined
                      :color="getUnitColor(item.current_owner.administrative_unit)"
                    >
                      {{ getUnitLabel(item.current_owner.administrative_unit) }}
                    </v-chip>

                    <v-chip
                      x-small
                      :color="getStatusColor(item)"
                      :class="getStatusTextColor(item)"
                    >
                      <v-icon size="12" left>{{ getStatusIcon(item) }}</v-icon>
                      {{ getStatusText(item) }}
                    </v-chip>
                  </v-layout>
                  <v-layout v-if="getDocumentPendingFolder(item)" align-center class="document-type-info mb-2">
                    <v-icon size="14" class="mr-1" :color="getDocumentIconColor(getDocumentPendingFolder(item))">
                      {{ getDocumentTypeIcon(getDocumentPendingFolder(item)) }}
                    </v-icon>
                    <span class="document-type-text">{{ getDocumentType(getDocumentPendingFolder(item)) }}</span>
                  </v-layout>
                  <v-btn
                    v-if="getDocumentPendingFolder(item)"
                    text
                    small
                    block
                    color="primary"
                    class="view-doc-btn mt-2"
                    @click.stop="showDocument(item, getDocumentPendingFolder(item))"
                  >
                    <v-icon size="16" left>mdi-file-eye</v-icon>
                    Visualizar documento
                  </v-btn>
                </v-layout>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { truncate } from 'lodash';
import AdminUnitMixin from '@/mixins/admin-unit-handling';
import draggable from "vuedraggable";

export default {
  name: 'PendingItemsTable',
  mixins: [AdminUnitMixin],
  components: {
    draggable
  },
  props: {
    items: {
      type: Array,
      required: true,
      default: () => []
    },
    draggingItemId: {
      type: [Number, String, null],
      default: null
    }
  },
  data() {
    return {
      viewMode: 'list',
      timer: null,
      dragDelay: 1500
    };
  },
  computed: {
    ...mapGetters(['user'])
  },
  methods: {
    startDrag(id) {
      this.$store.commit("setDraggingFolder", id);
    },
    startTimer(id) {
      this.timer = setTimeout(() => {
        this.setDraggingItem(id);
      }, this.dragDelay);
    },
    stopTimer() {
      clearTimeout(this.timer);
      this.setDraggingItem(null);
    },
    setDraggingItem(id) {
      this.draggingItemId = id;
    },
    truncateEntityName(entityName) {
      if (this.$vuetify.breakpoint.lgOnly) {
        return truncate(entityName, {length: 25});
      }
      if (this.$vuetify.breakpoint.xlOnly) {
        return truncate(entityName, {length: 50});
      }
      return truncate(entityName, {length: 15});
    },
    openFolder(id) {
      const route = this.$router.resolve(`/pastas/${id}/show`);
      window.open(route.href, "_blank");
    },
    getDocumentPendingFolder(folder) {
      if (!folder.documents) return null;
      const docs = folder.documents.filter(
        d => d.has_pending_signatures === true || d.has_pending_revision === true
      );
      return docs.length > 0 ? docs[0] : null;
    },
    getDocumentType(document) {
      return document && document.document_type ? document.document_type.name : 'Documento';
    },
    getDocumentTypeIcon(document) {
      if (!document || !document.document_type) return 'mdi-file-document-outline';

      // Mapeamento de tipos de documentos para ícones específicos
      const iconMapping = {
        'ofício': 'mdi-file-document',
        'memorando': 'mdi-file-account',
        'requerimento': 'mdi-file-certificate',
        'relatório': 'mdi-file-chart',
        'contrato': 'mdi-file-sign',
        'nota técnica': 'mdi-file-check',
        'parecer': 'mdi-file-star'
        // Adicione mais mapeamentos conforme necessário
      };

      // Tenta encontrar um ícone específico para o tipo, caso contrário use o padrão
      const docTypeLower = document.document_type.name.toLowerCase();
      for (const [key, icon] of Object.entries(iconMapping)) {
        if (docTypeLower.includes(key)) {
          return icon;
        }
      }

      return 'mdi-file-document-outline'; // Ícone padrão
    },
    getDocumentIconColor(document) {
      if (!document) return 'grey';
      if (document.has_pending_signatures) return 'blue';
      if (document.has_pending_revision) return 'orange darken-2';
      return 'grey';
    },
    showDocument(folder, document) {
      if (!document) return;
      const route = this.$router.resolve({
        path: `/pastas/${folder.id}/show`,
        query: {documentId: document.id}
      });
      window.open(route.href, "_blank");
    },
    // Métodos para formatação de datas
    formatDate(date) {
      if (!date) return 'Sem prazo';
      return new Date(date).toLocaleDateString('pt-BR');
    },
    // Calcula o tempo relativo (hoje, ontem, em 3 dias, etc.)
    getRelativeTime(date) {
      if (!date) return '';
      const today = new Date();
      const targetDate = new Date(date);
      const diffTime = targetDate - today;
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      if (diffDays === 0) return 'Hoje';
      if (diffDays === 1) return 'Amanhã';
      if (diffDays === -1) return 'Ontem';
      if (diffDays < 0) return `${Math.abs(diffDays)} dias atrás`;
      return `Em ${diffDays} dias`;
    },
    // Verifica se o prazo está vencido
    isOverdue(date) {
      if (!date) return false;
      const today = new Date();
      const targetDate = new Date(date);
      return targetDate < today;
    },
    // Métodos para manipulação de status
    getStatusColor(item) {
      if (item.received_status === 'Recebido') return 'success';
      if (item.received_status === 'Não Recebido') return 'amber darken-2';
      if (item.received_status === 'Recusado') return 'error';
      if (item.pending_type === 'review') return 'orange darken-2';
      if (item.pending_type === 'signature') return 'blue';
      return 'grey lighten-1';
    },
    getStatusTextColor(item) {
      // Para cores escuras, texto branco
      if (['Recebido', 'Recusado'].includes(item.received_status) ||
        ['signature'].includes(item.pending_type)) {
        return 'white--text';
      }
      // Para cores claras, texto escuro
      return 'grey--text text--darken-4';
    },
// Atualizar o método getStatusIcon para adicionar ícones que faltam
    getStatusIcon(item) {
      if (item.received_status === 'Recebido') return 'mdi-check-circle';
      if (item.received_status === 'Não Recebido') return 'mdi-clock-outline';
      if (item.received_status === 'Recusado') return 'mdi-close-circle';

      // Adicionar ícones mais descritivos e significativos
      if (item.pending_type === 'review') return 'mdi-file-document-edit';
      if (item.pending_type === 'signature') return 'mdi-pen'; // Alterando para um ícone de caneta para assinatura

      return 'mdi-clock-outline';
    },
    getStatusText(item) {
      if (item.received_status === 'Recebido') return 'Recebido';
      if (item.received_status === 'Não Recebido') return 'Aguardando';
      if (item.received_status === 'Recusado') return 'Recusado';

      // Usar apenas um método para determinar o status de pendência
      // Verificar primeiro o pending_type para priorizar essa informação
      if (item.pending_type === 'review') return 'Revisão';
      if (item.pending_type === 'signature') return 'Assinatura';

      // Default
      return 'Aguardando';
    },
    getInitials(owner) {
      if (!owner || !owner.name) return '?';
      return owner.name.split(' ').map(n => n[0]).join('').substring(0, 2).toUpperCase();
    }
  }
};
</script>

<style lang="scss" scoped>
// Variáveis para cores
$received-color: #4CAF50;
$waiting-color: #FFC107;
$refused-color: #F44336;
$review-color: #FF9800;
$signature-color: #2196F3;

// Vista em Lista - Melhorias
.pending-list-view {
  .pending-list-item {
    position: relative;
    margin-bottom: 16px;
    transition: transform 0.2s, box-shadow 0.2s;
    cursor: pointer;
    display: flex;
    border-radius: 4px;
    overflow: hidden;

    // Indicador colorido na borda lateral do card
    .status-indicator {
      width: 4px;
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;

      &.review {
        background-color: $review-color;
      }

      &.signature {
        background-color: $signature-color;
      }
    }

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.12) !important;
    }

    &.dragging {
      background-color: #e3f2fd;
      box-shadow: 0 8px 16px rgba(0, 0, 0, 0.12) !important;
    }
  }
}

.pending-item-container {
  width: 100%;
  border-radius: 4px;
  margin-left: 4px; // Espaço para o indicador colorido

  .pending-item-main {
    display: grid;
    grid-template-columns: 4fr 5fr 3fr 2fr;
    gap: 16px;
    padding: 16px;
    align-items: center;
    width: 100%;

    @media (max-width: 1280px) {
      grid-template-columns: 4fr 5fr 3fr 2fr;
    }

    @media (max-width: 960px) {
      grid-template-columns: 3fr 4fr 2fr 1fr;
      gap: 8px;
    }

    .folder-info {
      display: flex;
      align-items: center;

      .folder-icon-container {
        margin-right: 12px;

        .folder-icon {
          width: 28px;
          height: 28px;
        }
      }

      .folder-details {
        min-width: 0;

        .process-number {
          font-weight: 600;
          color: rgba(0, 0, 0, 0.8);
          font-size: 14px;
        }

        .folder-type-name {
          font-size: 12px;
          color: rgba(0, 0, 0, 0.6);
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }

    .document-type-info {
      background-color: rgba(0, 0, 0, 0.04);
      border-radius: 4px;
      padding: 4px 8px;
      margin: 4px 0;

      .document-type-text {
        font-size: 12px;
        color: rgba(0, 0, 0, 0.7);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 100%;
      }
    }

    .view-doc-btn {
      margin-top: 4px !important;
      text-transform: none !important;
      letter-spacing: 0 !important;
      cursor: pointer !important;
      background-color: rgba(33, 150, 243, 0.05) !important;

      &:hover {
        background-color: rgba(33, 150, 243, 0.12) !important;
      }
    }

    .entity-info {
      width: 100%;

      .entity-chip {
        height: auto;
        padding: 4px 8px;
        cursor: pointer;
        background-color: #f5f5f5;
        display: flex; /* Mudança crítica de inline-flex para flex */
        align-items: center;
        width: 100%;

        .v-avatar {
          flex: 0 0 auto; /* Não encolher, não crescer, tamanho base */
          margin-right: 4px;
        }

        .entity-name {
          flex: 1 1 auto; /* Crescer e encolher conforme necessário */
          min-width: 0; /* Importante para permitir o truncamento */
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-size: 13px;
          max-width: none !important; /* Sobrescreve o max-width do FolderCard */
        }
      }
    }

    .pending-item-owner {
      .owner-avatar {
        background: linear-gradient(135deg, #42a5f5, #1976d2);
        color: white;
        font-weight: 500;
      }

      .owner-name {
        font-size: 13px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 150px;
      }
    }

    .pending-item-deadline {
      .deadline-date {
        font-size: 13px;
        font-weight: 500;
      }

      .deadline-relative {
        color: rgba(0, 0, 0, 0.6);
        font-size: 12px;
      }
    }

    .pending-item-status {
      .status-chip {
        display: inline-flex;
        align-items: center;
        padding: 6px 16px;
        border-radius: 20px;
        font-size: 12px;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        will-change: transform;
        transform: translateZ(0);
        backface-visibility: hidden;
        line-height: 1.2;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
        border: 1px solid;
        min-width: 100px;
        justify-content: center;
        cursor: default !important;
        margin: 4px 0;

        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
        }

        .v-icon {
          font-size: 16px;
          margin-right: 6px;
          transition: transform 0.3s ease;
        }

        &:hover .v-icon {
          transform: scale(1.2);
        }

        &.success {
          background: linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%);
          color: #2e7d32;
          border-color: rgba(46, 125, 50, 0.2);
        }

        &.amber {
          background: linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%);
          color: #ef6c00;
          border-color: rgba(239, 108, 0, 0.2);
        }

        &.error {
          background: linear-gradient(135deg, #ffebee 0%, #ffcdd2 100%);
          color: #c62828;
          border-color: rgba(198, 40, 40, 0.2);
        }

        &.blue {
          background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
          color: #1565c0;
          border-color: rgba(21, 101, 192, 0.2);
        }

        &.orange {
          background: linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%);
          color: #ef6c00;
          border-color: rgba(239, 108, 0, 0.2);
        }
      }
    }
  }

  .pending-document-details {
    display: flex;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.03);
    padding: 12px 16px;
    width: 100%;
    border-top: 1px solid rgba(0, 0, 0, 0.06);
    border-radius: 0 0 4px 4px;

    .pending-document-indicator {
      display: flex;
      align-items: center;
      padding: 4px 10px;
      border-radius: 16px;
      margin-right: 16px;
      font-size: 12px;

      &.review-pending {
        background-color: $review-color;
        color: white;
      }

      &.signature-pending {
        background-color: $signature-color;
        color: white;
      }
    }

    .pending-document-info {
      flex: 1;

      .document-name {
        font-size: 13px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 400px;
      }
    }

    .pending-actions {
      margin-left: auto;

      .view-btn {
        text-transform: none;
        letter-spacing: 0;
        cursor: pointer !important;

        &:hover {
          background-color: rgba(33, 150, 243, 0.08);
        }
      }
    }
  }
}

// Vista em Grid - Melhorias
.pending-grid-view {
  .pending-grid-card {
    height: 100%;
    display: flex;
    flex-direction: column;
    transition: transform 0.2s, box-shadow 0.2s;
    position: relative;
    overflow: hidden;

    // Indicador colorido no topo baseado no tipo de pendência
    &.review-indicator::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 4px;
      background-color: $review-color;
      z-index: 1;
    }

    &.signature-indicator::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 4px;
      background-color: $signature-color;
      z-index: 1;
    }

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.12) !important;
    }

    .pending-grid-header {
      padding: 12px 16px;
      min-height: 56px;

      .process-number {
        font-weight: 600;
        font-size: 14px;
      }
    }

    .folder-icon {
      width: 24px;
      height: 24px;
    }

    .pending-grid-content {
      flex-grow: 1;
      padding: 16px;

      .folder-type-chip {
        background-color: #f5f5f5;
        color: rgba(0, 0, 0, 0.7);
        font-weight: 500;
        font-size: 12px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 100%;
        display: inline-block;
      }

      .entity-chip {
        height: auto;
        background-color: #f5f5f5;
        padding: 4px 8px;
        max-width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 12px;
      }

      .document-name {
        font-size: 13px;
        color: rgba(0, 0, 0, 0.7);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        display: flex;
        align-items: center;
      }
    }

    .pending-grid-footer {
      padding: 12px 16px;
      background-color: rgba(0, 0, 0, 0.02);

      .owner-avatar {
        background: linear-gradient(135deg, #42a5f5, #1976d2);
        color: white;
        font-weight: 500;
        font-size: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .owner-name {
        max-width: 120px;
        font-size: 13px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .view-doc-btn {
        margin-top: 8px;
        text-transform: none;
        letter-spacing: 0;
        cursor: pointer !important;

        &:hover {
          background-color: rgba(33, 150, 243, 0.08);
        }
      }
    }
  }
}

// Utilitários globais
.truncate-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.custom-tooltip {
  font-size: 14px;
  line-height: 1.5;
  white-space: normal;
  overflow-wrap: break-word;
  max-width: 500px;
}
</style>



// WEBPACK FOOTER //
// src/components/base/PendingItemsTable.vue